import { Link, Tooltip, Typography, PopperProps } from "@mui/material";
import { capitalDesignTokens } from "@opengov/capital-mui-theme";

import { SearchResultDisplayData } from "./SearchResultRow.types";

import { styles } from "./SearchResultRow-styles";

export type SearchResultRowProps = {
  data: SearchResultDisplayData;
  focused?: boolean;
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
  onMouseEnter?(event: React.MouseEvent<HTMLDivElement>): void;
};

const tooltipPopperOverrides: Partial<PopperProps> = {
  modifiers: [{ name: "offset", options: { offset: [0, -capitalDesignTokens.foundations.units.unit3] } }],
};

export const SearchResultRow = ({ focused, data, onClick, onMouseEnter }: SearchResultRowProps) => {
  const { title, documentType, tooltipMetadata } = data;

  const renderTooltipContent = (tooltipMetadata: SearchResultDisplayData["tooltipMetadata"]) => (
    <>
      {tooltipMetadata &&
        Object.entries(tooltipMetadata).map(([key, value]) => (
          <Typography key={key} component="div" variant="body2" data-test="tooltipMetadataRow">
            <strong data-test="tooltipMetadataKey">{key}:</strong> <span data-test="tooltipMetadataValue">{value}</span>
          </Typography>
        ))}
    </>
  );

  const renderLink = () => (
    <Link
      component="div"
      className={focused ? "focused" : ""}
      sx={styles.searchResultRow}
      onClick={onClick}
      data-test="searchResultRow"
      onMouseEnter={onMouseEnter}
    >
      <Typography component="span" variant="body1" sx={styles.searchResultTitle} data-test="searchResultTitle">
        {title}
      </Typography>
      <Typography
        component="span"
        variant="body2"
        sx={styles.searchResultDocumentType}
        data-test="searchResultDocumentType"
      >
        {documentType}
      </Typography>
    </Link>
  );
  if (tooltipMetadata) {
    return (
      <Tooltip
        open={focused}
        placement="top"
        enterDelay={0}
        componentsProps={{
          popper: tooltipPopperOverrides,
          tooltip: { sx: styles.tooltipContent },
        }}
        title={renderTooltipContent(tooltipMetadata)}
      >
        {renderLink()}
      </Tooltip>
    );
  }
  return renderLink();
};
